const organizationKeys = {
  base: ['organization_base'] as const,
  baseRef: (refId: string, refType: string) =>
    [...organizationKeys.base, refId, refType] as const,
};

export default organizationKeys;
